import { getHeaders } from "../../api/api";
import { readWorkflowBuilderResponse } from "../workflowBuilder/response";
import { dataScopeCatalogSchema, type DataScopeCatalog } from "./models";

export async function getWorkflowDataScopes(token: string | undefined, signal: AbortSignal): Promise<DataScopeCatalog> {
    const base = String(import.meta.env.VITE_BACKEND_URI ?? "").replace(/\/$/, "");
    const response = await fetch(`${base}/workflow-builder/data-scopes`, { headers: await getHeaders(token), cache: "no-store", signal });
    return dataScopeCatalogSchema.parse(await readWorkflowBuilderResponse(response));
}
